import axios from "axios";
import { domain } from "../Links/Links";
import { getCookie } from "../../App";

export async function exportRequest(setRecentSearchData) {
  const response = await axios.get(domain + "/export_recent_search/", {
    withCredentials: true,
  });

  setRecentSearchData(response.data);

}

export async function addRequest(username) {
  const data = {username:username};
  const response = await axios.post(domain + "/add_recent_search/", data, {
    withCredentials: true,
    headers: {
        'X-CSRFToken': getCookie('csrf_token'),
    },
  });

}



